export default __webpack_public_path__ + "static/media/VoxLogo.3d359dfa.png";